export const state = () => ({
  button: { value: '', id: '' },
});

export const mutations = {
  SET_VALUE(localstate, data) {
    localstate.button = data;
  },
};

export const actions = {
  setValue({ commit }, { stackIndex, value }) {
    commit('SET_VALUE', value);
    commit('chatbotStore/UPDATE_STACK_ITEM', { index: stackIndex, selectedButtonId: value.key }, { root: true });
  },
};

export default {
  namespaced: true,
  registered: false,
  state,
  mutations,
  actions,
};
